import {Dictionary} from 'lodash'

import {ensureList} from './typing'

export interface MetaData {
  key: string,
  value: string,
}

export function metaAsDict(metadata?: (MetaData | null)[] | null)  {
  const dict: Dictionary<string> = {}
  if (!metadata) {
    return dict
  }
  ensureList(metadata).forEach(({key, value}) => {
    dict[key] = value
  })
  return dict
}
